module.exports = __webpack_public_path__ + "img/iaas_catalogue.698e756.png";